import moment from 'moment';
import 'magnific-popup'

// Re-scroll to hash after all content (images, JS) has loaded and settled
if (window.location.hash) {
  window.addEventListener('load', function () {
    var target = document.querySelector(window.location.hash);
    if (target) {
      document.documentElement.style.scrollBehavior = 'auto';
      target.scrollIntoView();
      document.documentElement.style.scrollBehavior = '';
    }
  });
}

// Scroll-dimmed paragraphs — toggle visible/hidden as they scroll into their container
(function () {
  function makeDimmer(container, paragraphs) {
    if (!paragraphs.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('para-visible', entry.isIntersecting);
      });
    }, { root: container, threshold: 0.1, rootMargin: '0px 0px -25% 0px' });

    paragraphs.forEach(function (p, i) {
      if (i === 0) { p.classList.add('para-visible'); return; }
      observer.observe(p);
    });
  }

  var bioWrapper = document.querySelector('#about .bio-wrapper');
  if (bioWrapper) makeDimmer(bioWrapper, Array.from(bioWrapper.querySelectorAll('p')));

  var bio2 = document.querySelector('#about-2 .bio');
  if (bio2) makeDimmer(bio2, Array.from(bio2.querySelectorAll('.scroll-wrapper p')));
})();

// Scroll-triggered fade animations
(function () {
  var els = document.querySelectorAll('#about [data-fade], #about-2 [data-fade]');
  if (!els.length || !window.IntersectionObserver) return;

  els.forEach(function (el) {
    var delay = el.getAttribute('data-fade-delay');
    if (delay) el.style.setProperty('--fade-delay', delay + 'ms');
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  els.forEach(function (el) { observer.observe(el); });
})();

jQuery(document).ready(function ($) {
  /* -----------------------------
   * IMG CACHE BUSTER (optional)
   * --------------------------- */
  const cacheBuster = Date.now();
  $('img').each(function () {
    const $img = $(this);
    const src = $img.attr('src');
    if (!src) return;
    const sep = src.indexOf('?') !== -1 ? '&' : '?';
    $img.attr('src', src + sep + 'v=' + cacheBuster);
  });

  /* -----------------------------
   * ARTIST KEYS (unchanged)
   * --------------------------- */
  const artists = {
    "2 Chainz": { url: "https://www.2chainz.com/", image: "2-CHAINZ.jpg" },
    "21 Savage": { url: "https://www.21savage.com/", image: "21-savage.jpg" },
    "ASAP Rocky": { url: "https://www.instagram.com/asaprocky/", image: "ASAP-ROCKY.jpg" },
    "Beyoncé": { url: "https://www.beyonce.com/", image: "BEYONCE.jpg" },
    "Blac Youngsta": { url: "https://www.instagram.com/blacyoungsta/", image: "BLAC-YOUNGSTA.webp" },
    "Bossman Dlow": { url: "https://www.instagram.com/bossmandlo_/", image: "BOSSMAN-DLOW.jpg" },
    "Cardi B": { url: "https://www.cardib.com/", image: "CARDI-B.jpg" },
    "DJ Khaled": { url: "https://www.instagram.com/djkhaled/", image: "DJ-KHALED.jpg" },
    "Drake": { url: "https://drakerelated.com/", image: "DRAKE.webp" },
    "Drumma Boy": { url: "https://drummaboy.com/", image: "DRUMMA-BOY.jpg" },
    "Estelle": { url: "https://www.instagram.com/estelledarlings/?hl=en", image: "ESTELLE.jpg" },
    "Fetty Wap": { url: "https://www.instagram.com/fettywap1738/?hl=en", image: "FETTY-WAP.webp" },
    "Foogiano": { url: "https://www.instagram.com/foogiano/?hl=en", image: "FOOGIANO.jpg" },
    "French Montana": { url: "https://www.frenchmontanamusic.com/", image: "FRENCH-MONTANA.png" },
    "GloRilla": { url: "https://www.glorillaofficial.com/#/", image: "GLORILLA.webp" },
    "Gunna": { url: "https://www.instagram.com/gunna/?hl=en", image: "GUNNA.webp" },
    "Icewear Vezzo": { url: "https://www.instagram.com/icewear_vezzo/?hl=en", image: "ICEWEAR-VEZZO.webp" },
    "Jay-Z": { url: "https://www.instagram.com/jayz/?hl=en", image: "JAY-Z.webp" },
    "Kendrick Lamar": { url: "https://oklama.com/", image: "Kendrick-Lamar.jpg" },
    "Lil Baby": { url: "https://www.instagram.com/lilbaby/?hl=en", image: "LILBABY.jpg" },
    "Lil Donald": { url: "https://www.instagram.com/lildonald/?hl=en", image: "LIL-DONALD.JPG" },
    "Lil Duvaul": { url: "https://www.instagram.com/lilduval/", image: "LIL-DUVAUL.webp" }, // check spelling/filename
    "Lil Durk": { url: "https://www.onlythefamily.com/", image: "LIL-DURK.webp" },
    "Meek Mill": { url: "https://www.instagram.com/meekmill/", image: "MEEK-MILL.webp" },
    "Megan Thee Stallion": { url: "https://www.instagram.com/theestallion/", image: "MEGAN-THEE-STALLION.webp" },
    "Metro Boomin": { url: "https://www.instagram.com/metroboomin/", image: "METRO-BOOMIN.webp" },
    "Migos": { url: "https://www.instagram.com/migos/", image: "MIGOS.webp" },
    "Moneybagg Yo": { url: "https://www.instagram.com/moneybaggyo/", image: "MONEYBAGG-YO..webp" }, // double dot?
    "NBA YoungBoy": { url: "https://www.youngboynba.com/", image: "NBA-YOUNGBOY.jpg" },
    "Nicki Minaj": { url: "https://www.mypinkfriday.com/", image: "NICKI-MINAJ.webp" },
    "Omarion": { url: "https://www.instagram.com/omarion/", image: "OMARION.webp" },
    "Rae Sremmurd": { url: "https://www.instagram.com/raesremmurd/", image: "RAE-SREMMURD.jpg" },
    "Rich The Kid": { url: "https://www.instagram.com/richthekid/", image: "RICH-THE-KID.webp" },
    "Rick Ross": { url: "https://www.instagram.com/richforever/", image: "RICK-ROSS.jpg" },
    "Rihanna": { url: "https://www.fentybeauty.com/", image: "RIHANNA.webp" },
    "Robin Thicke": { url: "https://www.instagram.com/robinthicke/", image: "ROBIN-THICKE.webp" },
    "Rod Wave": { url: "https://www.instagram.com/rodwave/", image: "ROD-WAVE.webp" },
    "Sexyy Red": { url: "https://www.instagram.com/sexyyred/reels/", image: "SEXYY-RED.png" },
    "Tank": { url: "https://www.therealtank.com/", image: "TANK.webp" },
    "Tee Grizzley": { url: "https://teegrizzleymusic.com/", image: "TEE-GRIZZLEY.webp" },
    "The Weeknd": { url: "https://www.theweeknd.com/", image: "THE-WEEKND.jpg" },
    "Usher": { url: "https://www.usherworld.com/", image: "USHER.webp" },
    "Wale": { url: "https://www.walemusic.com/", image: "WALE.webp" },
    "Wiz Khalifa": { url: "https://wizkhalifa.com/", image: "WIZ-KHALIFIA.webp" }, // filename typo?
    "YFN Lucci": { url: "https://www.instagram.com/yfnlucci/", image: "YFN-LUCCI.jpg" },
    "YNW Melly": { url: "https://www.instagram.com/ynwmelly/", image: "YNW-Melly.webp" },
    "Yo Gotti": { url: "https://www.instagram.com/yogotti/", image: "YO-GOTTI.webp" },
    "Young Dolph": { url: "https://www.youngdolph.com/", image: "YOUNG-DOLPH.webp" },
    "Young Thug": { url: "https://www.instagram.com/thuggerthugger1/", image: "YOUNG-THUG.webp" }
  };

  const IMAGE_BASE = './dist/img/artists/';
  const $catalog = $('#catalog');
  const $ul = $('#roster');
  let firstLink = null;

  /* -----------------------------
   * Helpers
   * --------------------------- */
  const showBG = (src) => {
    if (!src) return;
    const img = new Image();
    img.onload = () => {
      $catalog
        .css({
          'background-image': `url("${src}")`,
          'background-position': 'center',
          'background-size': 'cover',
          'background-repeat': 'no-repeat'
        })
        .addClass('bg-visible');
    };
    img.src = src;
  };

  const setActive = ($a) => {
    $ul.find('a.is-active')
      .removeClass('is-active')
      .removeAttr('aria-current');

    $a.addClass('is-active').attr('aria-current', 'true');
    showBG($a.data('bg'));
  };

  /* -----------------------------
   * Build Roster UL
   * --------------------------- */
  $.each(artists, function (name, data) {
    const src = IMAGE_BASE + data.image;
    $('<img>').attr('src', src); // preload quietly

    const $a = $('<a>', {
      href: data.url,
      target: '_blank',
      rel: 'noopener',
      text: name
    }).data('bg', src);

    const $li = $('<li>').append($a);
    $ul.append($li);
    if (!firstLink) firstLink = $a;
  });

  if (firstLink) setActive(firstLink);

  // desktop hover/focus updates bg
  $ul.on('mouseenter focusin', 'a', function () {
    setActive($(this));
  });

  // prevent jump if "#" used
  $ul.on('click', 'a[href="#"]', function (e) {
    e.preventDefault();
  });

  /* -----------------------------
   * YEARS HOVER/CLICK LOGIC (unchanged)
   * --------------------------- */
  const $years = $('#years');
  const $yearsList = $years.find('.years-wrapper ul'); // container UL
  const $lis = $yearsList.find('li');
  const $items = $years.find('.content-wrapper .item');

  // Pick selected from .selected li, else from .item.active year class, else first li
  let selectedYear =
    $lis.filter('.selected').data('year') ||
    (($items.filter('.active').attr('class') || '').match(/\b\d{4}\b/) || [])[0] ||
    $lis.first().data('year');

  function show(year) {
    $items.hide().removeClass('active').filter('.' + year).show().addClass('active');
    $lis.removeClass('active').filter('[data-year="' + year + '"]').addClass('active');
  }

  // init
  $lis.removeClass('selected');
  $lis.filter('[data-year="' + selectedYear + '"]').addClass('selected');
  show(selectedYear);

  // hover preview
  $lis.on('mouseenter', function () {
    show($(this).data('year'));
  });

  // leave column -> revert
  $years.find('.years-wrapper').on('mouseleave', function () {
    show(selectedYear);
  });

  // click to set selection
  $lis.on('click', function (e) {
    e.preventDefault();
    selectedYear = $(this).data('year');
    $lis.removeClass('selected');
    $(this).addClass('selected');
    show(selectedYear);
  });

  /* -----------------------------
   * GALLERY LOGIC (unchanged)
   * --------------------------- */
  $('#gallery .gallery-grid').magnificPopup({
    delegate: 'a',
    type: 'inline',
    midClick: true,
    closeBtnInside: true,
    removalDelay: 180,
    mainClass: 'mfp-zoom-in',
    gallery: { enabled: true }
  });

  /* ------------------------------------------------------
   * MOBILE CENTER-TRACKING (Roster + Years) <= 767px
   * ---------------------------------------------------- */
  const mqMobile = window.matchMedia('(max-width: 767px)');

  // Generic center-tracking hook
  function createCenterTracker($scrollContainer, $itemsProvider, onCenter) {
    if (!$scrollContainer.length) return { enable: () => { }, disable: () => { } };

    let ticking = false;

    function updateActiveFromCenter() {
      const el = $scrollContainer[0];
      const rect = el.getBoundingClientRect();
      const centerY = rect.top + rect.height / 2;

      let $closest = null;
      let minDist = Infinity;

      $itemsProvider().each(function () {
        const r = this.getBoundingClientRect();
        const itemCenter = (r.top + r.bottom) / 2;
        const dist = Math.abs(itemCenter - centerY);
        if (dist < minDist) {
          minDist = dist;
          $closest = $(this);
        }
      });

      if ($closest) onCenter($closest);
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          updateActiveFromCenter();
          ticking = false;
        });
        ticking = true;
      }
    }

    function enable() {
      $scrollContainer.on('scroll.center', onScroll);
      updateActiveFromCenter();
      setTimeout(updateActiveFromCenter, 0);
    }

    function disable() {
      $scrollContainer.off('scroll.center');
    }

    return { enable, disable, force: updateActiveFromCenter };
  }

  // Tracker: Roster (#catalog)
  const $catalogScroll = $('#catalog .scroll-wrapper');
  const rosterTracker = createCenterTracker(
    $catalogScroll,
    () => $ul.children('li'),
    ($li) => { setActive($li.find('a')); }
  );

  // Tracker: Years (left column list)
  const $yearsScroll = $years.find('.years-wrapper .scroll-wrapper');
  const yearsTracker = createCenterTracker(
    $yearsScroll,
    () => $yearsList.children('li'),
    ($li) => { show($li.data('year')); }
  );

  function applyBehaviorForViewport() {
    if (mqMobile.matches) {
      // Roster: center tracking ON, hover/focus OFF (as you had)
      rosterTracker.disable(); // avoid dupes
      rosterTracker.enable();
      $ul.off('mouseenter');
      $ul.off('focusin');

      // Years: center tracking ON (hover events remain bound; no change in desktop behavior)
      yearsTracker.disable();
      yearsTracker.enable();
    } else {
      // Roster: center tracking OFF, hover/focus ON (as you had)
      rosterTracker.disable();
      $ul.off('mouseenter').on('mouseenter', 'a', function () { setActive($(this)); });
      $ul.off('focusin').on('focusin', 'a', function () { setActive($(this)); });

      // Years: center tracking OFF (all hover/click logic unchanged)
      yearsTracker.disable();
    }
  }

  applyBehaviorForViewport();
  mqMobile.addEventListener('change', applyBehaviorForViewport);

  // Re-evaluate on resize for mobile
  window.addEventListener('resize', () => {
    if (mqMobile.matches) {
      $catalogScroll.triggerHandler('scroll');
      $yearsScroll.triggerHandler('scroll');
    }
  });



  // BIO BUTTONS POPUPS
  // 1) Inject live bio content into the two popups
  var $aboutBio = $('#about .bio-wrapper');
  var $about2Bio = $('#about-2 .bio .scroll-wrapper');

  if ($aboutBio.length) {
    $('#bio-popup-1 .bio-content').html($aboutBio.html());
  }
  if ($about2Bio.length) {
    $('#bio-popup-2 .bio-content').html($about2Bio.html());
  }

  // 2) Initialize Magnific Popup for both inline modals
  //    (Assumes Magnific Popup CSS/JS is included in your bundle)
  if ($.fn.magnificPopup) {
    $('.mfp-inline').magnificPopup({
      type: 'inline',
      mainClass: 'mfp-fade',
      removalDelay: 150,
      midClick: true,
      fixedContentPos: true,
      overflowY: 'auto',
      closeBtnInside: true
    });
  } else {
    // Graceful fallback if Magnific isn't present: open/close with simple toggles
    $('.mfp-inline').on('click', function (e) {
      var target = $(this).attr('href');
      if (target && target.startsWith('#')) {
        e.preventDefault();
        $(target).toggleClass('is-open').attr('aria-hidden', function (i, val) {
          return val === 'true' ? 'false' : 'true';
        });
      }
    });
    // Optional: click outside to close fallback modals
    $(document).on('click', '.bio-popup.is-open', function (e) {
      if ($(e.target).is('.bio-popup.is-open')) {
        $(this).removeClass('is-open').attr('aria-hidden', 'true');
      }
    });
  }

  // HERO VIDEO LOOP
  $(function () {
    var $video = $('#heroVideo');

    // Original playlist
    var playlist = [
      "./dist/img/video/hero1.mp4",
      "./dist/img/video/hero2.mp4",
      "./dist/img/video/hero3.mp4"
    ];

    // Fisher–Yates shuffle
    function shuffle(array) {
      for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    }

    // Make a shuffled copy
    var shuffled = shuffle(playlist.slice());
    var current = 0;

    function playNext() {
      current = (current + 1) % shuffled.length;
      $video.attr('src', shuffled[current])[0].play();
    }

    // Bind ended event
    $video.on('ended', playNext);

    // Kick off first play
    $video.attr('src', shuffled[current])[0].play();
  });

});
